import React from 'react'
import { graphql, Link, StaticQuery } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'

const inventoryQuery = graphql`
  {
    allPrismicProduct(limit: 3, sort: { first_publication_date: DESC }) {
      edges {
        node {
          ...PrismicProductFragment
        }
      }
    }
  }
`

const Reserves = ({ slice }) => {
  return (
    <StaticQuery
      query={`${inventoryQuery}`}
      render={(data) => {
        if (!data) return null
        return (
          <section className='component-inventory mx-auto mb-12 w-full max-w-screen-xl px-6 pb-10'>
            <div className='mb-10 flex flex-col flex-wrap items-center justify-between space-y-2 px-4 pt-6 sm:flex-row sm:space-y-0 lg:px-0'>
              <div className='prose max-w-none text-center'>
                <PrismicRichText field={slice.primary.title.richText} />
              </div>
            </div>
            <ul className='grid grid-cols-1 gap-6 md:grid-cols-3'>
              {data.allPrismicProduct.edges.map((product, index) => {
                const productData = product.node.data

                return (
                  <li key={`product-${index}`} className='component-card ease relative flex flex-grow transform flex-col bg-white'>
                    <Link className='flex flex-1 flex-col' to={product.node.url}>
                      <div className='transform overflow-hidden transition duration-500'>
                        {productData.gallery.image?.gatsbyImageData ? (
                          <GatsbyImage className='aspect-video' image={productData.gallery.image.gatsbyImageData} alt={productData.gallery.image.alt || ''} />
                        ) : (
                          <div className='bg-stone-200 aspect-video' />
                        )}
                      </div>

                      <div className='m-4 flex flex-grow flex-col gap-4 md:m-8'>
                        <div>
                          {productData.status ? (
                            <span className='inline-flex items-center bg-pink-100 px-2.5 py-0.5 text-sm font-medium text-pink-800'>Sold</span>
                          ) : (
                            <span className='inline-flex items-center bg-green-100 px-2.5 py-0.5 text-sm font-medium text-green-800'>Available</span>
                          )}
                        </div>
                        <div className='prose max-w-none'>
                          <h3>{productData.page_title.text}</h3>
                        </div>
                        <div className='mb-6 mt-3 text-base text-stone-500'>
                          {productData.page_text.text?.split(' ').slice(0, 30).join(' ')}
                          {productData.page_text.text && <span>&hellip;</span>}
                        </div>
                      </div>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </section>
        )
      }}
    />
  )
}

export default Reserves
